import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { get } from "lodash";
import { getStakingContractInfo } from "../utils/bscHelpers";
import { helpers } from "../utils";
import RightBar from "./RightBar";
import { ACTION_CONST, APY_NOTICE_CONTENT } from "../constants";
import Footer from "../components/Footer";
import { changeTab } from "../../redux/action/app";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import $ from 'jquery';


const StakingPortalPage = ({ selectedTab, children }) => {
    const dispatch = useDispatch();
    const [stakerCount, setStakerCount] = useState(0);
    const [totalStakedAmount, setTotalStakedAmount] = useState(0);
    const [apyPercentage, setApyPercentage] = useState(0);
    const stakingInfo = useSelector((state) => get(state, "wallet.stakingInfo", {}));
    const submitOK = useSelector((state) =>
        get(state, "utils.blocking", false)
    );

    useEffect(() => {
        dispatch(changeTab(1));
    }, [])

    useEffect(() => {
        try {
            getStakingContractInfo().then(data => {
                setStakerCount(data.stakerCount);
                setTotalStakedAmount(data.totalStakedAmount);
                setApyPercentage(data.apyPercentage);
                dispatch({ type: ACTION_CONST.GET_STAKING_INFO, data: data });
            })
        } catch (error) {
            console.log(error);
        }

        //setup interval
        const job = setInterval(() => {
            getStakingContractInfo().then(data => {

                setStakerCount(data.stakerCount);
                setTotalStakedAmount(data.totalStakedAmount);
                setApyPercentage(data.apyPercentage);
                dispatch({ type: ACTION_CONST.GET_STAKING_INFO, data: data });
            })
        }, 10 * 1000);
        dispatch({ type: ACTION_CONST.SET_JOB_GET_STAKING_INFO, job });
    }, [dispatch, submitOK]);

    return (
        <>
            {
                stakingInfo["isStakingPaused"] &&
                <div className="container mt-4 text-center d-md-block d-none">
                    <span className="pp-banner-top">
                        <i className="mdi mdi-alert-outline me-2 text-danger">
                        </i> All staking functions are temporarily paused. Please check back again later.
                    </span>
                </div>
            }
            <div className="page-container">
                {
                    stakingInfo["isStakingPaused"] &&
                    <div className="container mt-4 text-center d-md-none d-block pp-notice">
                        <span className="pp-banner-top">
                            <i className="mdi mdi-alert-outline me-2 text-danger">
                            </i> All staking functions are temporarily paused. Please check back again later.
                        </span>
                    </div>
                }
                <div className="p-content">
                    <div className="container-fluid mt-3 p-scroll">
                        <div className="p-content-tabs">
                            <div className="mt-4 pb-4 mb-lg-5 text-center">
                                {selectedTab == 1 && <h4 className="p-tab-title mb-0">Stake your <span>$ASTRO</span></h4>}
                                {selectedTab == 2 && <h4 className="p-tab-title mb-0">Unstake your <span>$ASTRO</span></h4>}
                                {selectedTab == 3 && <h4 className="p-tab-title mb-0">Withdraw your <span>$ASTRO</span></h4>}
                            </div>
                            <div className="row gx-xl-5 justify-content-center align-items-start">
                                <div className="col-xl-8 col-lg-10 mt-xl-0">
                                    <div className="row">
                                        <div className="col-lg">
                                            <div className="tokenomics-block h-100--20">
                                                <div className="token-bold-text mb-2">Number of Stakers</div>
                                                <div className="token-text">{stakerCount}</div>
                                                <img src="/images/Bar-Icon.svg" loading="lazy" alt="Bar Icon" className="bar-icon" />
                                            </div>
                                        </div>
                                        <div className="col-lg">
                                            <div className="tokenomics-block h-100--20">
                                                <div className="token-bold-text mb-2">Total <span>$ASTRO</span> Staked</div>
                                                <div className="token-text">{helpers.formatNumberDownRound(totalStakedAmount, 2)}</div>
                                                <img src="/images/Bar-Icon.svg" loading="lazy" alt="Bar Icon" className="bar-icon" />
                                            </div>
                                        </div>
                                        <div className="col-lg">
                                            <div className="tokenomics-block h-100--20">
                                                <div className="token-bold-text mb-2">
                                                    <span>APY</span>
                                                    {/* <OverlayTrigger placement="top" overlay={<Tooltip id="button-tooltip">{APY_NOTICE_CONTENT}</Tooltip>}>
                                                        <span><i className="fas fa-info-circle"></i> &nbsp;APY</span>
                                                    </OverlayTrigger> */}
                                                </div>
                                                <div className="token-text">{helpers.formatNumberDownRound((apyPercentage / 100).toString(), 2)}%</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-content pt-5 mt-5" id="myTabContent">
                                {children}
                            </div>
                        </div>
                    </div>

                    <Footer />

                </div>

                <RightBar />
            </div>
        </>
    );
};

export default StakingPortalPage;
